import { useContext, useMemo } from "react";
import { Context } from ".";
import {
  DisplayConfiguration,
  isDisplayable,
} from "../../lib/operator-configuration/backoffice/display";

export const useOperatorDisplayConfiguration = (
  paths: (keyof DisplayConfiguration)[]
): boolean => {
  const { configuration, role } = useContext(Context);

  return useMemo(
    () => paths.every(path => isDisplayable(configuration || {}, path, role)),
    [paths, configuration, role]
  );
};
